module.exports = ".centered {\r\n    position: absolute;\r\n  left: 50%;\r\n  top: 30%;\r\n  -webkit-transform: translate(-50%, -50%);\r\n  transform: translate(-50%, -50%);\r\n  }"


//////////////////
// WEBPACK FOOTER
// ./src/opc/opc-app/error/error.component.css
// module id = ./src/opc/opc-app/error/error.component.css
// module chunks = main